export const errors = {
  transactionTypes: 'transaction_types',
}

export const returnReasonsFilteringTypes = {
  productTypes: 'product_types',
  productCategories: 'product_categories',
  productTags: 'product_tags',
}

export const availabilityModes = {
  all: 'all',
  ...returnReasonsFilteringTypes,
  nonExcludedProductTypes: 'non_excluded_product_types',
  nonExcludedProductCategories: 'non_excluded_product_categories',
  nonExcludedProductTags: 'non_excluded_product_tags',
}

export const notesAndImageValidationValues = {
  required: 'required',
  optional: 'optional',
  disabled: 'disabled',
}
